export const LOGIN_REQUESTED = 'LOGIN_REQUESTED';
export const LOGIN_APPROVED = 'LOGIN_APPROVED';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const SIGNOUT = 'SIGNOUT';
export const LAST_FIXING_DATE = 'LAST_FIXING_DATE';
export const LAST_BOE_DATE = 'LAST_BOE_DATE';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js